import React from 'react';
import { Card } from './ui/card';
import { Award, TrendingUp, Users, Target } from 'lucide-react';

export const About = () => {
  const features = [
  {
    icon: Award,
    title: 'Experiência',
    description: 'Anos de atuação no mercado industrial e automotivo'
  },
  {
    icon: Target,
    title: 'Compromisso',
    description: 'Foco em performance e continuidade operacional'
  },
  {
    icon: Users,
    title: 'Atendimento',
    description: 'Equipe profissional dedicada ao cliente B2B'
  },
  {
    icon: TrendingUp,
    title: 'Parceria',
    description: 'Relacionamento de longo prazo e transparente'
  }];


  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Sobre a SSA</span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold text-gray-900">
            Autoridade e Confiabilidade
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            A SSA DISTRIBUIDORA atua no fornecimento de soluções para a frota industrial, transportadoras e lojas de autopeças, 
            com foco em qualidade, disponibilidade, logística eficiente e parceria de longo prazo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-t-4 border-t-red-600">

                <div className="flex items-center justify-center w-14 h-14 bg-gray-100 rounded-lg mb-4">
                  <Icon className="text-gray-700" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </Card>);

          })}
        </div>

        {/* Value Proposition */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Por que escolher a SSA?
              </h3>
              <p className="text-lg text-gray-700 mb-6">
                Somos mais do que um fornecedor. Somos seu parceiro estratégico para garantir a continuidade e eficiência da sua operação.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-6 h-6 bg-red-600 rounded-full flex items-center justify-center mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="ml-3 text-gray-700 font-medium">Produtos originais e certificados</span>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-6 h-6 bg-red-600 rounded-full flex items-center justify-center mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="ml-3 text-gray-700 font-medium">Logística eficiente e pontual</span>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-6 h-6 bg-red-600 rounded-full flex items-center justify-center mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="ml-3 text-gray-700 font-medium">Suporte técnico especializado</span>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-6 h-6 bg-red-600 rounded-full flex items-center justify-center mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="ml-3 text-gray-700 font-medium">Estoque sempre disponível</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <div className="bg-white rounded-xl shadow-lg p-8">
                <div className="text-center">
                  <div className="text-5xl font-bold text-red-600 mb-2">SSA</div>
                  <div className="!font-semibold !text-xl mb-4 text-gray-900">DISTRIBUIDORA</div>
                  <div className="border-t-2 border-gray-200 pt-4 mt-4">
                    <p className="text-sm text-gray-600 italic">
                      "Onde outros veem metal, nós enxergamos propósito em continuidade"
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};